import React from 'react'

const CaesarCipherTheory = () => {
    return (
        <div>
            <ul>
                <li>
                    <p>
                        The Caesar cipher is a simple encryption technique that was used by Julius Caesar to send secret messages to his allies. It works by shifting the letters in the plaintext message by a certain number of positions, known as the “shift” or “key”.
                    </p>
                </li>
                <li>
                    <p>
                        The Caesar Cipher technique is one of the earliest and simplest methods of encryption technique. It's simply a type of substitution cipher, i.e., each letter of a given text is replaced by a letter with a fixed number of positions down the alphabet. For example with a shift of 1, A would be replaced by B, B would become C, and so on. The method is apparently named after Julius Caesar, who apparently used it to communicate with his officials.
                    </p>
                </li>
                <li>
                    <p>
                        Thus to cipher a given text we need an integer value, known as a shift which indicates the number of positions each letter of the text has been moved down.
                        The encryption can be represented using modular arithmetic by first transforming the letters into numbers, according to the scheme, A = 0, B = 1,…, Z = 25. Encryption of a letter by a shift n can be described mathematically as.
                    </p>
                </li>
                <li>
                    <p>
                        For example, if the shift is 3, then the letter A would be replaced by the letter D, B would become E, C would become F, and so on. The alphabet is wrapped around so that after Z, it starts back at A.
                    </p>
                </li>
            </ul>
        </div>
    )
}

export default CaesarCipherTheory